import { Injectable } from '@angular/core';
import { GlobalService } from 'src/app/_core/global.service';
import { LoginService } from './login.service';
import { EventsService } from './events.service';
import { OptinService } from 'projects/authentication/_services/optin.service';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DoOptinService {

  constructor(
    private global: GlobalService,
    private optinSvc: OptinService,
    private loginSvc: LoginService,
    private event: EventsService
  ) { }

  public init() {
    let searchParams = new URLSearchParams(location.search);
    let user = JSON.parse(localStorage.u || '{}');

    return this.optinSvc.getUser({ msisdnToken: searchParams.get(this.global.propConfs$.queryToken) || undefined }, searchParams.has('ut') ? atob(decodeURIComponent(searchParams.get('ut'))) : undefined).pipe(tap(authUser => {
      user = JSON.parse(localStorage.u || '{}');

      /* CHECK IF FLOW SHLOULD CONTINUE TO HTTPS */
      if (location.protocol == 'http:' && this.global.propConfs$.haveHttps && !searchParams.has('ut') && !~['localhost'].indexOf(location.hostname)) {
        location.href = `https://${location.host}${this.global.propConfs$.haveHE ? '?ut=' + btoa(user.j) : ''}`;
      } else {
        searchParams.delete('ut');

        if (authUser?.responseCode === 'SUCCESS' && authUser?.accessStatus === 'LOGGED') {
          let userSess = JSON.parse(sessionStorage.u || '{}');
          authUser.msisdn ? userSess.m = btoa(authUser.msisdn) : delete userSess.m;
          sessionStorage.u = JSON.stringify(userSess);

          this.loginSvc.doLogin(this.validateTraficType());
        } else if (authUser?.accessStatus === 'EXPIRED') {
          this.loginSvc.doLogOut();
        } else {
          /*-- DO NOTHING FOR NOW --*/
        }
      }
    }, noAuthUser => { console.debug('optin error', noAuthUser) }));
  }

  private validateTraficType(): boolean {
    let userSess = JSON.parse(sessionStorage.u || '{}');
    if (!~[1, 2, 3, 4].indexOf(userSess.tt)) {
      userSess.tt = 4;
      sessionStorage.u = JSON.stringify(userSess);
      // this.event.eventStart({ eventType: 'LOGIN', eventCategory: 'ACCESS' });
      return true;
    } else {
      return false;
    }
  }
}
